import React from "react";
import GiftCard from "@pages/GiftCard";

/**
 * GiftCardModal — backdrop wrapper that renders the shared GiftCard stepped flow
 * in "modal" mode (used from the onboarding "gift" choice). On mobile the
 * .gc-overlay becomes a bottom sheet (see giftcard.css).
 *
 * Props:
 *  - onClose: () => void
 *  - onSelfAdd: () => void  — the "I'll add photos myself" link continues the
 *                             normal onboarding gift flow.
 */
const GiftCardModal = ({ onClose, onSelfAdd }) => (
  <div className="gc-overlay" onClick={onClose}>
    <div onClick={(e) => e.stopPropagation()} style={{ width: "100%", maxWidth: "27rem" }}>
      <GiftCard mode="modal" onClose={onClose} onSelfAdd={onSelfAdd} />
    </div>
  </div>
);

export default GiftCardModal;
